(function(angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('ManageDevicesController', [
			'$rootScope',
			'SettingsFactory',
			'urlFactory',
			ManageDevicesControllerFunction
		]);

	function ManageDevicesControllerFunction(
		$rootScope,
		SettingsFactory,
		urlFactory
	) {
		var manageDevices = this;

		manageDevices.$onInit = function () {
			SettingsFactory.knownLoginDevices.get()
				.then(function (devices) {
					manageDevices.yourDevices = devices;
				});
		};

		manageDevices.openConfirmationModal = function(selectedDevice) {
			$rootScope.ModalFactory.openRemoveDevice(selectedDevice)
				.then(function (modal) {
					modal.close.then(function (result) {
						if (result && result.success) {
							urlFactory.redirect('/account/security/removedDevice/' + result.deviceId);
						}
					});
				});
		};
	}
})(window.angular);